import React, { useState } from "react";
import "./Question13.css";
import Meter from "./images/meter.png";
import Needle from "./images/needle.png";
import Gif1 from "./images/gif1-2.gif";
import Gif2 from "./images/gif3-4.gif";
import Gif3 from "./images/gif5-6.gif";
import Gif4 from "./images/gif7-8.gif";
import Gif5 from "./images/gif9-10.gif";

const Question13 = ({ onAnswer, userResponse }) => {
  const question = {
    title:
      "On a scale of 1 to 10, how confident are you about completing your research paper on time?",
    min: 1,
    max: 10,
  };

  const [value, setValue] = useState(userResponse[question.title] || 1);

  const calculateRotation = (val) => {
    if (val >= 1 && val <= 2) return -90;
    if (val >= 3 && val <= 4) return -50;
    if (val >= 5 && val <= 6) return 0;
    if (val >= 7 && val <= 8) return 50;
    if (val >= 9 && val <= 10) return 90;
    return -90;
  };

  const getGif = (val) => {
    if (val >= 1 && val <= 2) return Gif1;
    if (val >= 3 && val <= 4) return Gif2;
    if (val >= 5 && val <= 6) return Gif3;
    if (val >= 7 && val <= 8) return Gif4;
    if (val >= 9 && val <= 10) return Gif5;
    return Gif1;
  };

  const rotation = calculateRotation(value);
  const currentGif = getGif(value);

  const handleRangeChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    setValue(newValue);
    onAnswer(question.title, newValue);
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }
    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <div className="question13-container">
      <h2 className="question13-head">{question.title}</h2>

      <div className="emoji1">
        <img src={currentGif} alt="Emoji 1" className="emoji-gif" />
      </div>

      <div className="image-display">
        <img src={Meter} className="meter" alt="Confidence Level" />{" "}
        <img
          src={Needle}
          className="needle"
          alt="Confidence Level"
          style={{ transform: `rotate(${rotation}deg)` }}
        />
      </div>

      <div className="emoji2">
        <img src={currentGif} alt="Emoji 2" className="emoji-gif" />
      </div>

      <div className="range-input">
        <input
          type="range"
          min={question.min}
          max={question.max}
          step="1"
          value={value}
          onChange={handleRangeChange}
        />

        <div className="slider-labels">
          {Array.from({ length: question.max - question.min + 1 }, (_, i) => {
            const rangeValue = question.min + i;
            return (
              <span key={i} className={rangeValue === value ? "active" : ""}>
                {" "}
                {rangeValue}
              </span>
            );
          })}
        </div>
      </div>

      <button
        type="submit"
        onClick={handleNext}
        disabled={!userResponse[question.title]}
      >
        Next Question
      </button>
    </div>
  );
};

export default Question13;
